module.exports = __webpack_public_path__ + "static/media/tunel_1(1).39cdcbe8.jpg";